<div class="h-full relative">
  <div class="text-2xl text-gray-600 font-bold flex justify-between px-8 items-center ig-reviews-bg absolute h-[140px] w-full rounded-t-xl
    mobile:rounded-none mobile:!bg-none mobile:relative mobile:h-20">
    <div
      class="absolute left-0 bg-gradient-to-b from-[transparent] to-[gray] opacity-80 w-full h-[140px] mobile:hidden">
    </div>

    <div class="flex gap-2 items-center relative">
      <ig-image src="https://iti-images.s3.amazonaws.com/imgs/googlelogo_color_92x30dp.png" cls="w-[98px]"></ig-image>
      <span class="text-white mobile:text-gray-500">Reviews</span>
    </div>
    <mat-icon class="mr-2 cursor-pointer text-white relative mobile:text-gray-500" [matMenuTriggerFor]="menu"
      aria-label="sort">more_vert</mat-icon>

    <mat-menu #menu="matMenu" class="ig-review-sort">
      <button mat-menu-item (click)="sortReview('recency')">
        <span>Recency</span>
      </button>
      <button mat-menu-item (click)="sortReview('relevancy')">
        <span>Relevancy</span>
      </button>
      <!-- <button mat-menu-item (click)="sortReview('highest_rating')">
        <span>Highest rating</span>
      </button>
      <button mat-menu-item (click)="sortReview('lowest_rating')">
        <span>Lowest rating</span>
      </button> -->
    </mat-menu>
  </div>

  <div
    class="overflow-auto h-[94%] px-8 mt-[108px] pb-[78px] absolute w-full mobile:overflow-visible mobile:relative mobile:mt-0 mobile:pb-0 mobile:mb-8">
    <div *ngIf="!loading" class="flex flex-col gap-3 animate-bottom-up">
      <div class="min-w-[100%] border border-solid border-gray-200 rounded-xl p-3 bg-white shadow-sm"
        *ngFor="let review of reviews;let i = index" [class.blank-wrap]="!review.profile_photo_url">
        <div class="gap-3 flex items-center">
          <a class="profile-picture" target="_blank" [attr.href]="review.author_url">
            <ig-image [src]="review.profile_photo_url||defaultAvatar"
              cls="h-9 w-9 min-w-[36px] rounded-full aspect-square"></ig-image>
          </a>
          <a place target="_blank" [attr.href]="review.author_url">
            {{review.author_name}}
          </a>
        </div>
        <div #content class="mt-2 transition-all overflow-hidden"
          [class.h-[120px]]="readMoreCtrls[i]?.need&&!readMoreCtrls[i].show"
          [class.max-lines-5]="!readMoreCtrls[i]?.show" [class.max-h-fit]="readMoreCtrls[i]?.show===true">
          {{review.text}}
        </div>
        <div *ngIf="readMoreCtrls[i]?.need" class="text-[#3476d2] cursor-pointer hover:underline" (click)="show(i)">read
          {{readMoreCtrls[i].show ? 'less' : 'more'}}</div>

        <div class="post-footer">
          <!-- <ig-image *ngIf="review.photos.length" [src]="review.photos[0].url" cls="w-full"></ig-image> -->
          <img *ngIf="review.photos?.length" [src]="review.photos[0].url" alt="">
          <div class="flex">
            <mat-icon *ngFor="let rate of toArray(+review.rating)" class="!text-base !w-5">star</mat-icon>
          </div>

          <a class="text-sm italic" [href]="review.url" target="_blank">{{getTime(review)}}</a>
        </div>
      </div>

      <div *ngIf="!reviews.length" class="mt-[120px]">
        <ig-no-content></ig-no-content>
      </div>
    </div>

    <div *ngIf="loading" class="flex justify-center h-full">
      <div class="ig-google-loader relative top-[40%]"></div>
    </div>

  </div>